import React, { Component } from "react";
import "react-bootstrap";
import { connect } from "react-redux";
import $ from "jquery/dist/jquery.js";

import { PagesForCaption, CaptionCodes } from "../../../config/Helper";
import { lang } from "../../../config/lang";

class RightBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      news: false,
      experience: false,
      agency: false,
      particle: false,
      information: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {}

  componentWillReceiveProps(newProps) {
    if (newProps.homeSection.news !== undefined) {
      this.setState({
        news: newProps.homeSection.news,
      });
    }

    if (newProps.homeSection.experience !== undefined) {
      this.setState({
        experience: newProps.homeSection.experience,
      });
    }

    if (newProps.homeSection.agency !== undefined) {
      this.setState({
        agency: newProps.homeSection.agency,
      });
    }

    if (newProps.homeSection.particle !== undefined) {
      this.setState({
        particle: newProps.homeSection.particle,
      });
    }

    if (newProps.homeSection.information !== undefined) {
      this.setState({
        information: newProps.homeSection.information,
      });
    }
  }

  handleScroll(event) {
    if (window.scrollY > 500) {
      $("#nav_box").addClass("show-me");

      window.activeRightBarItem();
    } else {
      $("#nav_box").removeClass("show-me");
    }
  }

  handleMovePosition(id) {
    var top = $("#" + id)[0].offsetTop;
    $(document).scrollTop(top + 550);
  }

  render() {
    return (
      <nav className="ftco-navbar-light site-navbar-target">
        <div
          id="nav_box"
          ref="navbox"
          className="collapse navbar-collapse header-floating"
          style={{ display: "none" }}
        >
          <ul className="navbar-nav nav sidebar-nav  ml-auto">
            <li className="nav-item shortbar-item">
              <a
                href="#home-section"
                className="nav-link sidebar-link"
                title=""
              >
                <i className="icon icon-arrow-up"></i>
              </a>
            </li>
          </ul>
          <ul className="navbar-nav nav sidebar-bottom-nav ml-auto">
            {/* {
                            this.state.news && 
                            <li className="nav-item shortbar-item">
                                <a href="#news-section" className="nav-link sidebar-link" 
                                    title={this.props.sectionTitle[CaptionCodes[PagesForCaption.indexOf('home')].indexOf('home_news')] === undefined ?
                                    "" : this.props.sectionTitle[CaptionCodes[PagesForCaption.indexOf('home')].indexOf('home_news')].title}>
                                    <i className="icon icon-newspaper-o"></i>
                                </a>
                            </li>
                        } */}
            <li className="nav-item shortbar-item">
              <span
                onClick={() => {
                  this.handleMovePosition("destinationListSection");
                }}
                className="nav-link sidebar-link"
                title={lang("destination")}
              >
                <i className="icon icon-drivers-license-o"></i>
              </span>
            </li>
            <li className="nav-item shortbar-item">
              <span
                onClick={() => {
                  this.handleMovePosition("serviceListSection");
                }}
                className="nav-link sidebar-link"
                title={lang("service")}
              >
                <i className="icon icon-restaurant"></i>
              </span>
            </li>
            <li className="nav-item shortbar-item">
              <span
                onClick={() => {
                  this.handleMovePosition("placeListSection");
                }}
                className="nav-link sidebar-link"
                title={lang("place")}
              >
                <i className="icon icon-domain"></i>
              </span>
            </li>
            {this.state.experience && (
              <li className="nav-item shortbar-item">
                <span
                  onClick={() => {
                    this.handleMovePosition("experience-section");
                  }}
                  className="nav-link sidebar-link"
                  title={
                    this.props.sectionTitle[
                      CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                        "home_testimony"
                      )
                    ] === undefined
                      ? ""
                      : this.props.sectionTitle[
                          CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                            "home_testimony"
                          )
                        ].title
                  }
                >
                  <i className="icon icon-twitch"></i>
                </span>
              </li>
            )}
            {this.state.agency && (
              <li className="nav-item shortbar-item">
                <span
                  onClick={() => {
                    this.handleMovePosition("agency-section");
                  }}
                  className="nav-link sidebar-link"
                  title={
                    this.props.sectionTitle[
                      CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                        "home_agency"
                      )
                    ] === undefined
                      ? ""
                      : this.props.sectionTitle[
                          CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                            "home_agency"
                          )
                        ].title
                  }
                >
                  <i className="icon icon-ticket"></i>
                </span>
              </li>
            )}
            {/* {
                            this.state.particle &&
                            <li className="nav-item shortbar-item">
                                <a href="#photo-article-section" className="nav-link sidebar-link" 
                                    title={this.props.sectionTitle[CaptionCodes[PagesForCaption.indexOf('home')].indexOf('home_photo_article')] === undefined ?
                                    "" : this.props.sectionTitle[CaptionCodes[PagesForCaption.indexOf('home')].indexOf('home_photo_article')].title}><i className="icon icon-camera2"></i>
                                </a>
                            </li>
                        } */}
            {this.state.information && (
              <li className="nav-item shortbar-item">
                <span
                  onClick={() => {
                    this.handleMovePosition("information-section");
                  }}
                  className="nav-link sidebar-link"
                  title={
                    this.props.sectionTitle[
                      CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                        "home_information"
                      )
                    ] === undefined
                      ? ""
                      : this.props.sectionTitle[
                          CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                            "home_information"
                          )
                        ].title
                  }
                >
                  <i className="icon icon-help_outline"></i>
                </span>
              </li>
            )}
          </ul>
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    homeSection: state.homeSection,
  };
}

export default connect(mapStateToProps)(RightBar);
